/**
 * Tiny class-name joiner; avoids a dependency for the common case.
 *
 * It joins and nothing more: two classes that set the same property (`bg-transparent` and
 * `bg-brand-wash`) both land on the element, and whichever Tailwind emits later wins — not the one
 * listed last. Put the alternatives in one ternary, never a resting class plus an `active &&` one.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
